<template>
    <div class="supplementBox">
        <div class="supplement">
            <h4>上传答辩证据</h4>
            <p style="border: 1px solid #3b63f6"></p>
        </div>
        <div style="margin: 30px 0px">
<!--            仲裁答辩书-->
            <div class="matter">
                <div class="fileContent">
                    <p>仲裁答辩书:</p>
                </div>
                <el-upload
                        ref='upload'
                        class="inline"
                        :limit="10"
                        :on-preview="handlePreview"
                        :on-remove="(file, fileList) => {handleRemove(file, fileList, upload_data.doc_type)}"
                        :on-success="handleSuccess"
                        :on-exceed="handleExceed"
                        accept=".pdf,.png,.jpg,.zip,.rar,.docx,.doc"
                        :headers="headers"
                        :action="url"
                        name="file"
                        :data="upload_data"
                        :file-list="application"
                        :on-progress="onProgress"

                >
                    <el-button class="custom">
                        上传
                    </el-button>
                </el-upload>
            </div>
<!--            其他-->
            <div class="matter">
                <div class="fileContent">
                    <p>其他证据:</p>
                </div>
                <el-upload
                        ref='upload'
                        class="inline"
                        :limit="10"
                        :on-preview="handlePreview"
                        :on-remove="(file, fileList) => {handledelete(file, fileList, other_data.doc_type)}"
                        :on-success="handleSuccess"
                        :on-exceed="handleExceed"
                        accept=".pdf,.png,.jpg,.zip,.rar,.docx,.doc"
                        :headers="headers"
                        :action="url"
                        name="file"
                        :data="other_data"
                        :file-list="otherList"
                        :on-progress="onProgress"
                >
                    <el-button class="custom">
                        上传
                    </el-button>
                </el-upload>
            </div>
        </div>
        <div class="save" style="margin: auto;">
            <el-button  class="save" @click="save">保存文书</el-button>
        </div>
    </div>
</template>

<script>
    import { plea, respondent } from '../../../api/arbitrationCase';

    export default {
        name: 'defenseEvidence',
        data(){
            return{
                url:process.env.VUE_APP_BASE_API+'/api/upload_zhcai_bei_file',
                headers:{
                    "Authorization": sessionStorage.getItem("token"),
                    "Comid": sessionStorage.getItem("shenfen"),
                    "Platformsn":JSON.parse(localStorage.getItem('userData')).platform_sn
                },
                upload_data:{
                    case_id:0,  //仲裁案件id
                    doc_type:'1',  //文书类型：1仲裁答辩书；2其他证据材料
                },
                other_data:{
                    case_id:0,  //仲裁案件id
                    doc_type:'2',  //文书类型：1仲裁答辩书；2其他证据材料
                },
                //答辩书
                dabianshu:{
                    psd_codes:[],
                },
                //其他证据
                qitazhengju:{
                    psd_codes:[],
                },
                application:[],
                otherList:[],
            }
        },
        methods:{
            //点击文件列表事件
            handlePreview(file){
                if (file.all_url){
                    const link = document.createElement("a"); //自己创建的a标签
                    link.href = file.all_url+'?v='+Math.random();
                    link.target="_blank"
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(file.all_url);
                }else if (file.response){
                    const link = document.createElement("a"); //自己创建的a标签
                    link.href = file.response.data.all_url+'?v='+Math.random();
                    link.target="_blank"
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(file.response.data.all_url);
                }
            },
            //仲裁答辩书移除
            handleRemove(file, fileList,lawOffice){
                this.dabianshu.psd_codes.forEach((item,index)=>{
                    if (item == file.psd_code){
                        this.dabianshu.psd_codes.splice(index,1)

                    }
                })
            },
            //其他证据移除
            handledelete(file,fileList,lawOffice){
                this.qitazhengju.psd_codes.forEach((item,index)=>{
                    if (item == file.psd_code){
                        this.qitazhengju.psd_codes.splice(index,1)
                    }
                })
            },
            //上传成功
            handleSuccess(response, file, fileList){
                if (response.code==200){
                    // 将 psd_code 赋值给 file 对象，以便删除时使用
                    file.psd_code = response.data.psd_code;
                    if (response.data.doc_type==1){
                        this.dabianshu.psd_codes.push(response.data.psd_code)
                    }else if(response.data.doc_type==2){
                        this.qitazhengju.psd_codes.push(response.data.psd_code)
                    }
                        this.$message.success(response.msg);
                }else {
                    this.$message.error(response.msg);
                }

            },
            //限制条数
            handleExceed(files, fileList){
                if (fileList.length>=10){
                    this.$message.error('只能上传10个文件');
                }
            },
            //保存
            save(){
                plea(this.$route.query.id,this.dabianshu,this.qitazhengju).then(res=>{
                    if (res.code==200){
                        this.$message.success(res.msg);
                    }else {
                        this.$message.error(res.msg);
                    }
                })
            },
            //上传文件进度未上传完成时添加loading
            onProgress({ percent }) {
                if (percent!==100){
                    this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                }else {
                    this.$loading().close()
                }
            }
        },
        created() {
            this.headers.Comid=JSON.parse(sessionStorage.getItem("shenfen")).com_id
            this.upload_data.case_id=this.$route.query.id
            this.other_data.case_id=this.$route.query.id
            respondent(this.$route.query.id).then(res=>{
                if (res.data.dabianshu!=''&&res.data.dabianshu!=undefined){
                    this.application=res.data.dabianshu
                    res.data.dabianshu.forEach(item=>{
                            // 确保每个 file 对象都有 psd_code 属性
                            item.psd_code = item.psd_code;
                            this.dabianshu.psd_codes.push(item.psd_code)
                    })
                }
                if (res.data.qitazhengju!=''&&res.data.qitazhengju!=undefined){
                    this.otherList=res.data.qitazhengju
                    res.data.qitazhengju.forEach(item=>{
                            // 确保每个 file 对象都有 psd_code 属性
                            item.psd_code = item.psd_code;
                            this.qitazhengju.psd_codes.push(item.psd_code)
                    })
                    
                }
            })
        }
    };
</script>

<style scoped>
    .supplementBox{
        width: 100%;
        min-width: max-content !important;
        padding: 30px;
        background-color: #fff;
        border-radius: 5px;
    }
    .supplement>h4{
        width: 120px;
        color: #3e60f5;
        text-align: center;
        margin-bottom: 8px;
    }
    .supplement>p{
        width: 120px;
    }
    .matter{
        display: flex;
        align-items: center;
        margin: 10px 0px;
    }
    .inline{
        /*width: 50%;*/
        height: 32px;
        margin: 0px 15px;
        display: flex;
        align-items: center;
    }
    /deep/.el-upload--text{
        margin: 0px 20px;
        width: 60px;
        line-height: 30px;
        height: 100%;
        border: 0px;
        color: #fff;
    }
    .custom{
        background-color: #3f5cf7;
        color: #fff;
    }
    .save{
        width: 120px;
        background-color: #3b63f6;
        color: #fff;
        height: 40px;
        border-radius: 5px;
    }
    .prompt{
        margin:20px 0px;
        color: red;
    }
    .fileContent>p{
        width: 100px;
        color: #666666;
        font-size: 14px;
    }
    /deep/.el-upload-list{
        /*width: 150px;*/
        display: flex;
        align-items: flex-end;
    }
</style>
